module.exports = __webpack_public_path__ + "static/media/ha.fe5dfe58.svg";